module.exports = __webpack_public_path__ + "img/01.853949c7.png";